import { Box } from "@cjdev-internal/visual-stack-x/Box";
import { Text } from "@cjdev-internal/visual-stack-x/Text";
import { useIntl } from "hooks";
import React from "react";
import messages from "../messages";
import { DateMetric, EngagementMetric, NumericMetric } from "../metrics";
import { MetricsGrid } from "../MetricsGrid";

export const TwitterMetrics = ({ metrics }) => {
  const intl = useIntl();
  return (
    <Box direction="column" gap="2xl">
      <MetricsGrid>
        <NumericMetric name="followers" value={metrics.followers} />
        <DateMetric name="lastPostDate" value={metrics.lastPostDate} />
        <NumericMetric name="totalLikes" value={metrics.totalLikes} />
        <NumericMetric
          name="accountTotalTweets"
          value={metrics.accountTotalTweets}
        />
        <NumericMetric
          name="accountLikesPerTweet"
          value={metrics.accountLikesPerTweet}
        />
      </MetricsGrid>
      <Box direction="column" gap="large">
        <Text weight="medium" size={14}>
          {intl.formatMessage(messages.timePeriodLast20Posts)}
        </Text>
        <MetricsGrid>
          <EngagementMetric
            label={metrics.engagementLabel}
            rate={metrics.engagementRate20Posts}
            socialPlatform="twitter"
          />
          <NumericMetric
            name="likesPerPost20Posts"
            value={metrics.likesPerPost20Posts}
          />
          <NumericMetric
            name="commentsPerPost20Posts"
            value={metrics.commentsPerPost20Posts}
          />
          <NumericMetric
            name="sharesPerPost20Posts"
            value={metrics.sharesPerPost20Posts}
          />
        </MetricsGrid>
      </Box>
    </Box>
  );
};
